import React, { Fragment, useEffect, useState } from 'react'
import { superAxiosRequest } from 'axiosApi'
import cogoToast from 'cogo-toast'
import { dateFormat } from 'helpers/date'
import useTableFixedHeader from 'hooks/useTableFixedHeader'
import ContentHeader from '../ContentHeader'
import Filter from '../Filter/Filter'
import THead from './THead'
import Loader from '../Loader/Loader'
import st from './Table.module.scss'
import { splitNumberDigits } from 'helpers/math'

export default function ReceiptFunds() {
  const cfg = {
    cols: [
      { name: 'Локация' },
      { name: 'Банк' },
      { name: 'Месяц' },
      { name: 'День' },
      { name: 'Студент, описание платежа' },
      { name: 'Сумма, тг' },
    ],
  }

  const {
    refWrapper,
    refSticky,
    refThead,
    data,
    setData,
    isLoading,
    setIsLoading,
  } = useTableFixedHeader()

  const today = new Date()

  const [groupCatalog, setGroupCatalog] = useState({})
  const [filter, setFilter] = useState({
    date_from: new Date(today.getFullYear(), today.getMonth(), 1),
    date_until: new Date(today.getFullYear(), today.getMonth() + 1, 0),
  })

  const filterCfg = [
    {
      type: 'select-custom',
      placeholder: 'Локация',
      values: groupCatalog.locations?.items,
      sort_key: 'name',
      nameState: 'locations',
      is_multi: true,
    },
    { type: 'month-range-picker', nameState: ['date_from', 'date_until'] },
  ]

  const formatNumber = (num) =>
    splitNumberDigits((num / 100).toFixed(2).replace('.', ','))

  useEffect(() => {
    const apiConf = {
      method: 'get',
      link: 'groups/groups_catalog',
    }
    superAxiosRequest(apiConf).then((res) => {
      setGroupCatalog(res.data)
    })
  }, [])

  useEffect(() => {
    if (!filter.date_from || !filter.date_until) {
      cogoToast.info('Установите даты для применения фильтра.')
      return
    }

    setIsLoading(true)
    setData(null)

    const y = filter.date_until.getFullYear(),
      m = filter.date_until.getMonth()

    const params = {
      ...filter,
      date_from: dateFormat(filter.date_from, 'YYYY-mm-dd'),
      date_until: dateFormat(new Date(y, m + 1, 0), 'YYYY-mm-dd'),
    }
    const apiConf = {
      method: 'get',
      link: 'payments/funds_receipt_report',
      params,
    }
    superAxiosRequest(apiConf)
      .then((res) => {
        setData(res.data)
        setIsLoading(false)
      })
      .catch(() => {
        setData({})
        setIsLoading(false)
        cogoToast.warn('Что-то пошло не так :(', { heading: 'Ошибка сервера' })
      })
  }, [filter, setData, setIsLoading])

  return (
    <>
      <ContentHeader title='Приход денежных средств' />
      <Filter config={filterCfg} drop={() => {}} getFilterParams={setFilter} />

      {data && (
        <div className={st.tableWrapper} ref={refWrapper}>
          <div ref={refSticky} className={st.sticky}>
            <table className={st.table}>
              <THead cols={cfg.cols} />
            </table>
          </div>
          <table className={st.table}>
            <THead cols={cfg.cols} ref={refThead} />
            <tbody className={`${st.tbody} ${st.tbodyStriped}`}>
              {Array.isArray(data.months) &&
                data.months.map((monthData, im) => (
                  <Fragment key={im}>
                    {Array.isArray(monthData.days) &&
                      monthData.days.map((dayData, id) => (
                        <Fragment key={id}>
                          {Array.isArray(dayData.clients) &&
                            dayData.clients.map((clientData, ic) => (
                              <tr key={ic}>
                                {ic === 0 && (
                                  <>
                                    {/* Локация */}
                                    <td
                                      rowSpan={dayData.clients.length}
                                      className={st.bgw}
                                    >
                                      {dayData.location}
                                    </td>
                                    {/* Банк */}
                                    <td
                                      rowSpan={dayData.clients.length}
                                      className={st.bgw}
                                    >
                                      {dayData.bank}
                                    </td>
                                    {/* Месяц */}
                                    <td
                                      rowSpan={dayData.clients.length}
                                      className={st.bgw}
                                    >
                                      {monthData.month}
                                    </td>
                                    {/* День */}
                                    <td
                                      rowSpan={dayData.clients.length}
                                      className={st.bgw}
                                    >
                                      {dayData.day}
                                    </td>
                                  </>
                                )}
                                {/* Клиент и сумма */}
                                <td className={`${st.fz12} ${st.bdb}`}>
                                  {clientData.client}
                                </td>
                                <td
                                  colSpan={2}
                                  className={`${st.textAlignCenter} ${st.fz12} ${st.bdb}`}
                                >
                                  {formatNumber(clientData.amount)}
                                </td>
                              </tr>
                            ))}
                          {/* ИТОГО за день */}
                          {dayData.total && (
                            <tr className={`${st.bdt} ${st.nobr}`}>
                              <td colSpan={5} className={st.tdTotal}>
                                Итого {dayData.day} {monthData.month}
                              </td>
                              <td
                                className={`${st.tdTotal} ${st.textAlignCenter}`}
                              >
                                {formatNumber(dayData.total)}
                              </td>
                            </tr>
                          )}
                        </Fragment>
                      ))}
                    {/* Итог по месяцу */}
                    {monthData.days && (
                      <tr className={`${st.bdt} ${st.nobr}`}>
                        <td colSpan={5} className={st.tdTotal}>
                          Итого за {monthData.month}
                        </td>
                        <td className={`${st.tdTotal} ${st.textAlignCenter}`}>
                          {formatNumber(
                            monthData.days.reduce(
                              (acc, d) => acc + (d.total || 0),
                              0,
                            ),
                          )}
                        </td>
                      </tr>
                    )}
                  </Fragment>
                ))}
              {/* Общий итог по all_total */}
              {data.all_total && (
                <tr className={`${st.bdt} ${st.nobr}`}>
                  <td colSpan={5} className={st.tdTotal}>
                    Итого всего
                  </td>
                  <td className={`${st.tdTotal} ${st.textAlignCenter}`}>
                    {formatNumber(data.all_total)}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {isLoading && <Loader />}
    </>
  )
}
